import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ModalWindow from '../ModalWindow/ModalWindow';
import ModalButton from '../ModalWindow/ModalButton/ModalButton';
import './ConstructionActionsConfirmModal.css';
import {CONSTRUCTIONS_COLOR, WAR_COLOR} from '../../../styles/constants';
import {selectShowNoConstructionActionsModal} from '../../../redux/reducers/privateStateReducer/selectors';
import {hideNoConstructionActionsModal} from '../../../redux/actions';
import store from '../../../redux/store';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {handleCompleteTurn} from '../../../utils/gameState/turn/handleCompleteTurn';
import {selectCurrentPlayer} from '../../../redux/reducers/sharedStateReducer/selectors';
import {selectPhaseProgress} from '../../../utils/gameState/progress/selectPhaseProgress';
import {pluralizeRu} from '../../../utils/other/pluralizeRu';

const selectConstructionDeeds = (state) => {
  const playerId = selectCurrentPlayer(state)?.id;
  const {done, actionableIds} = playerId ? selectPhaseProgress(state, playerId) : {done: null, actionableIds: []};
  return {used: done || 0, left: actionableIds.length};
};

/**
 * Подтверждение завершения хода в фазе строительства: без единого действия
 * (см. CompletePhaseButton: гейт активен до 10 раунда включительно) или, по
 * Enter, с оставшимися действиями (spec unit-auto-selection, «Завершение
 * этапа клавишей Enter»).
 * Смонтирована на уровне GameContent (как и прочие модалки) — иначе, будучи
 * вложенной внутрь Header/CompletePhaseButton, она попадала бы в чужой
 * stacking context и рисовалась под боковыми панелями несмотря на z-index.
 */
const ConstructionActionsConfirmModal = () => {
  const dispatch = useDispatch();
  const showModal = useSelector(selectShowNoConstructionActionsModal);
  const {used, left} = useSelector(selectConstructionDeeds, (a, b) => a.used === b.used && a.left === b.left);

  if (!showModal) {
    return null;
  }

  const handleCancel = () => {
    dispatch(hideNoConstructionActionsModal());
  };

  const handleConfirm = () => {
    dispatch(hideNoConstructionActionsModal());
    handleCompleteTurn(store, true, true, REGISTRY_SINGLETON.getSoundManager());
  };

  return (
    <ModalWindow handleClose={handleCancel} className={'construction-actions-confirm-modal'}>
      <div className="construction-actions-confirm-modal-content">
        <h2>
          {used > 0 && left > 0
            ? `У вас осталось ${left} ${pluralizeRu(left, 'действие', 'действия', 'действий')}`
            : 'Вы не выполнили ни одного действия'}
          <img
            className="construction-actions-confirm-modal-action-img"
            src={'/img/icons/action.png'}
            alt={'Действие'}
          />
          <br/>
          {'в '}
          <span style={{color: CONSTRUCTIONS_COLOR}}>фазе Строительства</span>
          {'.'}
          <br/>
          {'Уверены, что хотите завершить ход?'}
        </h2>
      </div>

      <div className="construction-actions-confirm-modal-footer">
        <ModalButton
          onClick={handleConfirm}
          text={'Подтвердить'}
          className={'construction-actions-confirm-modal-button'}
          style={{backgroundColor: WAR_COLOR}}
        />
        <ModalButton
          onClick={handleCancel}
          text={'Вернуться'}
          className={'construction-actions-confirm-modal-button'}
        />
      </div>
    </ModalWindow>
  );
};

export default ConstructionActionsConfirmModal;
